import moment from 'moment';
import { dateFormat } from '../../../constants';
import { getStopApi } from '../../../services/StopApi/StopApi';

export const getTreatmentList = async ({ commonParams, authorization }) => {
  return await getStopApi({
    commonParams,
    authorization,
  }).then((response) => {
    const json = response.data;
    return {
      isLoading: false,
      total: response?.totalRows,
      data: json?.map((item, index) => ({
        ...item,
        id: index,
        CDCNumber: item.CBPAuth?.cboAthSapAth?.episode?.CDCNumber
          ? item.CBPAuth?.cboAthSapAth?.episode?.CDCNumber
          : '-',
        epdID: item.CBPAuth?.cboAthSapAth?.episode?.epdID
          ? item.CBPAuth?.cboAthSapAth?.episode?.epdID
          : '-',
        epdDate: item.CBPAuth?.cboAthSapAth?.episode?.epdDate
          ? moment(item.CBPAuth?.cboAthSapAth?.episode?.epdDate)
              .format(dateFormat)
              .split('T')[0]
          : '-',
        athDate: item.CBPAuth?.cboAthSapAth?.athDate
          ? moment(item.CBPAuth?.cboAthSapAth?.athDate)
              .format(dateFormat)
              .split('T')[0]
          : '-',
        sapAthID: item.CBPAuth?.cboAthSapAth?.sapAthID
          ? item.CBPAuth?.cboAthSapAth?.sapAthID
          : '-',
        CBPAthID: item.CBPAuth?.CBPAthID ? item.CBPAuth?.CBPAthID : '-',
        endDate: item.CBPAuth?.endDate
          ? moment(item.CBPAuth?.endDate).format(dateFormat).split('T')[0]
          : '-',
        cBPName: item.CBPAuth?.cboAthSapAth?.CBO?.cBPName
          ? item.CBPAuth?.cboAthSapAth?.CBO?.cBPName
          : '-',
        cbpID: item.CBPAuth?.cboAthSapAth?.CBO?.cbpID
          ? item.CBPAuth?.cboAthSapAth?.CBO?.cbpID
          : '-',
        TmtID: item.TmtID ? item.TmtID : '-',
        Date: item.Date
          ? moment(item.Date).format(dateFormat).split('T')[0]
          : '-',
        treatmentTypeId: item.treatmentType?.id ? item.treatmentType?.id : '-',
        treatmentStsId: item.treatmentSts?.id ? item.treatmentSts?.id : '-',
        rte: item.rte?.id ? item.rte?.id : '-',
        cbpInv: item.cbpInv?.id ? item.cbpInv?.id : '-',
        Amount: item.Amount ? item.Amount : '-',
      })),
    };
  }).catch((e) => alert(e));
};
